import { useRef, type ReactNode } from 'react';
import { createApiClient } from '@/shared/api';
import { getToken } from '@/shared/auth';
import { readEnv } from '@/shared/config';
import {
  createSchedulesApi,
  SchedulesApiProvider,
  type SchedulesApiClient,
} from '@/entities/schedule';

const authProvider = { getToken };

export interface AppSchedulesApiProviderProps {
  children: ReactNode;
  /** Override the API client — intended for tests only. */
  client?: SchedulesApiClient;
}

export function AppSchedulesApiProvider({
  children,
  client,
}: AppSchedulesApiProviderProps) {
  const clientRef = useRef<SchedulesApiClient | null>(null);
  if (client === undefined && clientRef.current === null) {
    const baseUrl = readEnv('VITE_API_BASE_URL') ?? '';
    clientRef.current = createSchedulesApi(createApiClient({ baseUrl, auth: authProvider }));
  }

  const resolvedClient = client ?? clientRef.current;
  if (resolvedClient === null) {
    throw new Error('AppSchedulesApiProvider could not initialize a schedules API client');
  }

  return (
    <SchedulesApiProvider client={resolvedClient}>
      {children}
    </SchedulesApiProvider>
  );
}
